import { GlobalSettings } from './globalSettings';
import { applyDefaultSettings, SupportedSettings } from './setting-definitions';

const settingsInstance = new GlobalSettings<SupportedSettings>();

// Apply all initial default settings to the settings instance
applyDefaultSettings(settingsInstance);

export { settingsInstance as settings };
